import { useUiStore } from '@/store/ui.store';

export const GlobalLoader = () => {
  const isLoading = useUiStore((state) => state.isLoading);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-[#05BFA0] border-t-transparent" />
        <p className="text-sm font-medium text-gray-700">Loading...</p>
      </div>
    </div>
  );
};

